module.exports = __webpack_public_path__ + "static/media/AdobeStock.14af38fe.png";